<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Fee Category</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link :to="{ name: 'AddFeeType' }" class="button is-info is-small btnicon" title="Add">
              <b-icon icon="plus" size="is-small" />
            </router-link>
          </div>
          <!-- <div class="level-item">
            <a class="button is-small is-link" @click="enableFilterModal = !enableFilterModal" title="Filter">
              <b-icon icon="filter" size="is-small"></b-icon>
            </a>
          </div> -->
        </div>
      </div>
      Total Records :
      <b>{{ this.total }}</b>
    </section>
    <section class="section is-main-section">
      <card-component title class="has-table has-mobile-sort-spaced">
        <b-table paginated :per-page="perPage" :striped="true" :hoverable="true" :data="feeCategoryData" style="overflow-x:scroll">
          <template slot-scope="props">
            <b-table-column label="Serial No" sortable> {{ props.index + 1 }} </b-table-column>
            <b-table-column field="name" label="Name" sortable>{{ props.row.name }}</b-table-column>
            <b-table-column field="priority" label="Priority" sortable>{{ props.row.priority }} </b-table-column>

            <b-table-column field="isService" label="Is Service" sortable>{{ props.row.isService?'Yes':'No' }} </b-table-column>
            <b-table-column field="serviceCategories" label="Service Categories" sortable>
              {{ props.row.serviceCategories[0]? props.row.serviceCategories[0].name:'' }}
              </b-table-column>

            <b-table-column field="level" label="level" sortable>{{ props.row.level }} </b-table-column>
            <b-table-column label="Status" field="isActive" sortable centered>
              <span v-bind:class="getClass(props.row.isActive)" class="is-medium is-capitalized">{{ props.row.isActive ? 'Active' : 'deactive' }}</span>
            </b-table-column>
            <b-table-column field="classes" label="Total Classes" sortable>
              {{ props.row.feeCategoryClassMaps && props.row.feeCategoryClassMaps.length ? props.row.feeCategoryClassMaps.length : '0' }}</b-table-column
            >
            <b-table-column field="classes" label="Total Fee Types" sortable>
              {{ props.row.feeCategoryFeeTypeMaps && props.row.feeCategoryFeeTypeMaps.length ? props.row.feeCategoryFeeTypeMaps.length : '0' }}</b-table-column
            >
            <!-- <b-table-column field="feeTypeCategory.name " label="Category" sortable> {{ props.row.feeTypeCategory.name }}</b-table-column> -->

            <!-- <b-table-column field="isBreakout" label="Is Breakout" sortable><span v-if="props.row.isBreakout === true">Yes</span> <span v-else>No</span> </b-table-column> -->

            <!-- <b-table-column field="isInventory" label="Is Inventory " sortable><span v-if="props.row.isInventory === true"> Yes</span> <span v-else>No</span> </b-table-column> -->

            <!-- <b-table-column field="isExcessAmount" label="Is ExcessAmount" sortable><span v-if="props.row.isExcessAmount === true">Yes</span> <span v-else>No</span> </b-table-column> -->

            <!-- <b-table-column field="isServiceBased" label="Is Service Based" sortable><span v-if="props.row.isServiceBased === true">Yes</span> <span v-else>No</span> </b-table-column> -->
            <!-- <b-table-column field="isStudentSpecific" label="Is Student Specific " sortable><span v-if="props.row.isStudentSpecific === true">Yes</span> <span v-else>No</span> </b-table-column>
            <b-table-column field="isVisibleToParent" label="Is VisibleTo Parent" sortable><span v-if="props.row.isVisibleToParent === true">Yes</span> <span v-else>No</span> </b-table-column> -->

            <b-table-column label="Action" centered>
              <div class="buttons">
                <router-link :to="{ name: 'EditFeeType', params: { id: props.row.id } }" class="button is-info is-small btnicon" title="Edit">
                  <b-icon icon="pencil" size="is-small" />
                </router-link>
                <button class="button is-small is-primary" type="button" @click="viewMore(props.row)" title="View More..">
                  <b-icon icon="eye" size="is-small" />
                </button>
                <button class="button is-small is-danger" type="button" @click.prevent="deleteFee(props.row.id)" title="Delete..">
                  <b-icon icon="trash-can" size="is-small" />
                </button>
              </div>
            </b-table-column>

            <div class="modal" :class="{ 'is-active': enableFilterModal }">
              <div class="modal-background"></div>
              <form class="modal-card" style="width:45rem;">
                <header class="modal-card-head">
                  <p class="modal-card-title">
                    <strong>
                      Fee Cateory:-&nbsp;&nbsp;
                    </strong>
                  </p>
                  <button class="delete" type="button" @click="enableFilterModal = false"></button>
                </header>

                <section class="modal-card-body">
                  {{ viewMoreData[0] && viewMoreData[0].name ? viewMoreData[0].name : '-' }}

                  <b-table paginated :per-page="perPage" :striped="true" :hoverable="true" :data="viewMoreData ? viewMoreData : []" style="overflow-x:scroll">
                    <template slot-scope="props1">
                      <b-table-column width="30" label="Classes " centered sortable>
                        <div v-for="c in props1.row.feeCategoryClassMaps" :key="c.id">
                          <b-tag class="tag is-medium is-capitalized"> {{ c.studentClass.name }}</b-tag>
                        </div>
                      </b-table-column>
                      <b-table-column width="30" label="Fee Type " centered sortable>
                        <div v-for="c in props1.row.feeCategoryFeeTypeMaps" :key="c.id">
                          <b-tag class="tag is-medium is-capitalized"> {{ c.feeType.name }}</b-tag>
                        </div>
                      </b-table-column>
                      <b-table-column field="description" label="Description" sortable> {{ props1.row.description }}</b-table-column>
                      <b-table-column field="isCompensation" label="Is Compensation" sortable>
                        <b-tag class="is-medium" type="is-info"><span v-if="props1.row.isCompensation === true"> Yes</span> <span v-else>No</span></b-tag>
                      </b-table-column>
                      <b-table-column field="isMandatory" label="Is Mandatory" sortable><span v-if="props1.row.isMandatory === true">Yes</span> <span v-else>No</span> </b-table-column>

                      <b-table-column field="isRefundable" label="Is Refundable" sortable><span v-if="props1.row.isRefundable === true">Yes</span> <span v-else>No</span> </b-table-column>
                    </template>
                  </b-table>
                  <hr />
                  <div class="columns form-row">
                    <div class="column has-text-right"></div>
                  </div>
                </section>
              </form>
            </div>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>Nothing here.</p>
              </div>
            </section>
          </template>
        </b-table>
      </card-component>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'

export default {
  name: 'FeeTypeList',
  components: {
    CardComponent
  },
  data () {
    return {
      feeCategoryData: [],
      total: 0,
      paginated: false,
      perPage: 10,
      loadingComponent: null,
      enableFilterModal: false,
      viewMoreData: []
    }
  },
  created () {
    this.getFeeTypeList()
  },
  methods: {
    viewMore: function (data) {
      this.viewMoreData = [data]

      this.enableFilterModal = true
    },
    getFeeTypeList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/fee-category`)
        this.feeCategoryData = response ? response.data : []

        if (!this.feeCategoryData) {
          this.total = 0
        } else {
          this.total = this.feeCategoryData.length
        }

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getClass: function (isActive) {
      return !isActive ? 'tag is-danger' : 'tag is-success'
    },
    deleteFee: async function (id) {
      this.$buefy.dialog.confirm({
        title: 'Delete fee structure',
        message: 'Do you really want to <b>delete</b> this record?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            await http.delete(`${constants.API_URL}/api/fee-category/${id}`)
            this.getFeeTypeList()
            return this.$buefy.dialog.alert({
              type: 'is-success',
              message: 'Deleted Successfully',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.buttons {
  flex-wrap: nowrap;
}
</style>
